// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__18SCB","choiceBoxes":"toolbarselects_choiceBoxes__3e67R","simpleField":"toolbarselects_simpleField__1nhAs"};